// Families, the way musicmap colours super-genres: coarse enough that the eye
// learns them in a few seconds. Drawn from the same set the chronology's
// periods use, so the map looks like it belongs to this site.
//
// The colour is on the DOT, never on the label — these are chosen to be
// distinguishable from each other, not to be readable as text on the ground.
export const GROUP_COLOR = {
  planet: "#e2b76b",
  metal: "#9fb0c4",
  sephirah: "#b29bc8",
  path: "#9a8fd0",
  weekday: "#87b28a",
  element: "#ca9298",
  quality: "#8bb8c9",
  hebrew_letter: "#c493b7",
  letter_class: "#b58fc0",
  cosmological_sphere: "#75b2a5",
  sign: "#809dcc",
  house: "#aaad78",
  angel: "#71a9c1",
  planetary_intelligence: "#91b5ca",
  angelic_choir: "#6fa8bd",
  divine_name: "#d8c98a",
  spirit: "#c184a8",
  tarot: "#b99b78",
  colour: "#998fc8",
  stone: "#a8b4a0",
  plant: "#8ab27f",
  animal: "#c9a06d",
  region: "#7f9aa8",
  body_part: "#c99a9a",
  number: "#c7b3d4",
  rank: "#c184a8",
  // Egyptian gods and the Greek names Herodotus gives them. Two families
  // rather than one, because an edge between them is the whole point of
  // having either: a line from Osiris to Dionysos has to be visibly a line
  // BETWEEN two things and not inside one.
  egyptian: "#cf9f6a",
  deity: "#b5897f",
  ritual_office: "#9bb09b",
  other: "#9aa2ae"
};

export const GROUP_LABEL = {
  planet: "Planets", metal: "Metals", sephirah: "Sephiroth", path: "Paths",
  weekday: "Days of the week", element: "Elements", quality: "Qualities",
  hebrew_letter: "Hebrew letters", letter_class: "Classes of letter",
  cosmological_sphere: "Spheres", sign: "Zodiac signs", house: "Houses",
  angel: "Archangels", planetary_intelligence: "Planetary intelligences", angelic_choir: "Angelic choirs",
  divine_name: "Divine names", spirit: "Goetic spirits", tarot: "Tarot cards",
  colour: "Colours", stone: "Stones", plant: "Plants", animal: "Animals",
  region: "Countries and provinces", body_part: "Parts of the body",
  number: "Numbers", rank: "Ranks of spirit",
  egyptian: "Egyptian gods", deity: "Gods of other pantheons",
  ritual_office: "Offices in a ritual",
  other: "Other"
};

// The order the picker lists them in: the classical table first, then the
// things Agrippa lists by the dozen. Same reasoning as Prominence, and for the
// same reason — it is about how load-bearing a kind is, never how true.
export const GROUP_ORDER = [
  "planet", "metal", "weekday", "number", "sephirah", "element", "sign", "path",
  "cosmological_sphere", "angel", "planetary_intelligence", "angelic_choir", "divine_name",
  "hebrew_letter", "letter_class", "tarot", "colour", "quality", "body_part",
  "rank", "stone", "animal", "plant", "region", "house", "spirit",
  "egyptian", "deity", "ritual_office", "other"
];

export const labelFor = (group) => GROUP_LABEL[group] || group;

export const colorFor = (group) => GROUP_COLOR[group] || GROUP_COLOR.other;

// Every node's page is its key under this section. The payload used to spell
// this out per node, which was ten kilobytes of the same prefix.
export const hrefFor = (key) => `/correspondences/${key}`;
